import { supabase } from '../../supabase'
import type {
  ActivityPayload,
  ActivityRow,
  DatabaseRow,
  RepositoryResult,
} from '../types/database.types'
import { failure, success } from './result'

export const ActivitiesRepository = {
  async listByProspectId(
    prospectId: string,
  ): Promise<RepositoryResult<ActivityRow[]>> {
    const { data, error } = await supabase
      .from('activities')
      .select('*')
      .eq('prospect_id', prospectId)
      .order('occurred_at', { ascending: false })

    return error ? failure(error) : success((data ?? []) as ActivityRow[])
  },

  async findFollowUpActivity(
    prospectId: string,
    scheduledAt: string,
  ): Promise<RepositoryResult<ActivityRow | null>> {
    const { data, error } = await supabase
      .from('activities')
      .select('*')
      .eq('prospect_id', prospectId)
      .eq('activity_type', 'follow_up')
      .eq('next_follow_up_at', scheduledAt)
      .eq('result', 'scheduled')
      .maybeSingle()

    return error
      ? failure(error)
      : success((data ?? null) as ActivityRow | null)
  },

  async getLatestChannel(
    prospectId: string,
  ): Promise<RepositoryResult<DatabaseRow | null>> {
    const { data, error } = await supabase
      .from('activities')
      .select('activity_type, channel')
      .eq('prospect_id', prospectId)
      .order('occurred_at', { ascending: false })
      .limit(1)
      .maybeSingle()

    return error
      ? failure(error)
      : success((data ?? null) as DatabaseRow | null)
  },

  async create(
    payload: ActivityPayload,
  ): Promise<RepositoryResult<ActivityRow>> {
    const { data, error } = await supabase
      .from('activities')
      .insert(payload)
      .select('*')
      .single()
    return error ? failure(error) : success(data as ActivityRow)
  },
}
